export function checkValidEmail(email) {
  const pattern = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/g);
  const isValidEmail = pattern.test(email);

  return isValidEmail;
}
